import axios from "axios";
import React, { SyntheticEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import '../../../Styles/Login.css'
import 'bootstrap/dist/css/bootstrap.css';
import { Usuario } from "../../../Models/Cadastros/Usuario/Usuario";
import TextFieldComponent from "../../../Components/Forms/TextFieldComponent";
import { useSnackbar } from "notistack";
import LoadingComponent from "../../../Components/Navigations/Loading";

const LoginPage = () => {
    const [currentUser, setCurrentUser] = useState(new Usuario());
    const [disabled, setDisabled] = useState(true);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    const [user, setUser] = useState<any | null>(() => {
        const storedUser = localStorage.getItem("user");
        return storedUser ? JSON.parse(storedUser) : {};
    });
    
    const [preferences, setPreferences] = useState<any | null>(() => {
        const storedPreferences = localStorage.getItem("preferences");
        return storedPreferences ? JSON.parse(storedPreferences) : [];
    });

    const submit = async (e: SyntheticEvent) => {
        e.preventDefault();

        try {
            setLoading(true);
            const response = await axios.post("login", currentUser);
            if (response.status === 200) {
                let responseUsuario = await axios.get('usuario');
                setUser(responseUsuario.data);
                localStorage.setItem("user", JSON.stringify(responseUsuario.data));

                responseUsuario.data.habilita_modo_dark ??= window.matchMedia("(prefers-color-scheme: dark)").matches;

                let preferences = {'darkMode':responseUsuario.data.habilita_modo_dark};
                setPreferences(preferences);
                localStorage.setItem("preferences", JSON.stringify(preferences));
                
                document.documentElement.setAttribute("data-theme", responseUsuario.data.habilita_modo_dark ? 'dark' : 'light');
                
                navigate("/");

                window.location.reload();
            }
            else {
                enqueueSnackbar('Acesso negado!', {variant: 'error'});
            }
        } catch (error) {
            enqueueSnackbar('Acesso negado!', {variant: 'error'});
        }
        finally {
            setLoading(false);
        }
    }

    setTimeout(
        function () {
            setDisabled(false);
        }, 1000);

    useEffect(function () {
        document.body.style.backgroundImage = "linear-gradient(rgb(22, 22, 22), black)";
    }, [])
    
    return (
        <div>
            <LoadingComponent show={loading} />
            <main className="container form-signin">
                <form className="panel panel-default col-md-12" autoComplete="false" onSubmit={submit}>                    
                    <div className="panel-login">
                        <div className="panel-login-logo2">
                            <img src="/Logo_C2_TOWER.svg" width={'400em'} />
                            {/* <img src="/c2_logo_transparent.png" width={'100em'} />
                            <span className="panel-login-font-logo panel-login-font-logo-1">2</span>
                            <span className="panel-login-font-logo panel-login-font-logo-2">TOWER</span> */}
                        </div>

                        <div className="panel-body">
                            <div className="form-floating panel-login-input">
                                <TextFieldComponent label='Usuário' model={currentUser} field='usuario' className="form-control text-field-login" variant="filled" required disabled={disabled} />
                            </div>
                            <div className="form-floating panel-login-input">
                                <TextFieldComponent label="Senha" model={currentUser} field='senha' type="password" className="form-control text-field-login" variant="filled" required disabled={disabled} />
                            </div>

                            <button className="w-100 btn btn-lg btn-dark btn-login" type="submit">Entrar</button>
                        </div>
                    </div>
                </form>
            </main>
        </div>
    );
}

export default LoginPage;